export * from 'utils/cookies';

import { h } from 'preact';
import Store from 'store/store';

import 'utils/cookies.sss';

const getOneTrustCookieSettingButtonText = (() => {
	let cache = null;
	return () => {
		if (cache) return cache;
		if (typeof window?.OneTrust?.GetDomainData !== 'function') {
			return null;
		}
		return cache = window.OneTrust.GetDomainData()?.CookieSettingButtonText || null;
	};
})();

export function showCookieConsent() {
	window.OneTrust?.ToggleInfoDisplay?.();
}

export function renderCookieConsentLink(linkName) {
	const store = Store.get();
	const clientGeo = store.client?.geo;
	const studioRoot = store.appData?.urls?.roots?.studio || '';
	let name = getOneTrustCookieSettingButtonText() || linkName;

	return (
		<button class="cookie-consent" onClick={showCookieConsent}>
			{clientGeo?.countryCode === 'us' && <img class="do-not-sell" src={`${studioRoot}/images/ccpa-icon/privacyoptions.svg`} role="presentation" />}
			{name}
		</button>
	);
}